import React from "react";
import Container from "../components/Container/index";

function TechSkills() {
  return (
    <Container>
      <div>
        <h3>Technical Skills</h3>
        <ul>
            <li>HTML</li>
            <li>Css</li>
            <li>JavaScript</li>
            <li>Mongo DB</li>
            <li>MySQL</li>
            <li>React.js</li>
            <li>Node.js</li>
            <li>Express.js</li>
        </ul>
      </div>
    </Container>
  );
}

export default TechSkills;